<template>
  <div>
    <XcalacocoBookingsFilters :isLoading="isLoading" :initialFilters="initialFilters" @search="search" />
    <hr>
    <b-table
      responsive
      small
      show-empty
      :items="rows"
      :fields="fields"
      :busy="isLoading"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="id"
      empty-text="No se encontraron reservas con los filtros seleccionados."
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" /> <strong>Cargando reservas</strong>
        </div>
      </template>

      <template #cell(folio)="row">
        <router-link
          :to="{ name: 'xcalacoco-booking-detail', params: { id: row.item.id }, query: lastFilters }"
          class="font-weight-bolder text-nowrap"
        >{{ row.item.folio }}</router-link>
        <div v-if="row.item.reservanumber"><small class="text-muted text-nowrap">Loc: {{ row.item.reservanumber }}</small></div>
      </template>

      <template #cell(housingnumber)="row">
        <div class="font-weight-bolder">{{ row.item.housingnumber }}</div>
        <small class="text-muted">{{ row.item.ownerName }}</small>
      </template>

      <template #cell(dateIn)="row">
        <div class="text-nowrap">{{ formatDay(row.item.dateIn) }} → {{ formatDay(row.item.dateOut) }}</div>
        <small class="text-muted">{{ nightsLabel(row.item) }}</small>
      </template>

      <template #cell(occupancy)="row">
        <span class="text-nowrap" :title="guestNames(row.item)">
          <strong>{{ row.item.adults }}</strong> adultos · <strong>{{ row.item.children }}</strong> menores
        </span>
      </template>

      <template #cell(statusname)="row">
        <b-badge pill :class="'bg-' + statusVariant(row.item.status)">{{ row.item.statusname }}</b-badge>
      </template>
    </b-table>

    <PaginationTable
      v-if="rows.length > perPage"
      :key="searchCount"
      :currentPage="currentPage"
      :totalRows="rows.length"
      :perPage="perPage"
      @change-page="changePage"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { showAlertMessage } from '@/helpers/helpers'
import {
  formatXcalacocoDay, xcalacocoNightsLabel, xcalacocoStatusVariant, xcalacocoGuestNames,
} from '@/helpers/xcalacocoBookingsHelper'
import { xcalacocoBookingsFields } from '@/data/xcalacocoBookings'
import PaginationTable from '@/modules/fivesClub/components/catalogs/ownersBookings/list/PaginationTable'
import XcalacocoBookingsFilters from '@/modules/fivesClub/components/catalogs/ownersBookings/xcalacoco/XcalacocoBookingsFilters'

const FALLBACK_MESSAGE = 'Ocurrió un error al procesar la solicitud.'
const FILTER_KEYS = ['status', 'dateType', 'startDate', 'endDate', 'numberHousing', 'nameOwner']

// Rebuilds the last search from the query the detail view sends back. A bare `?status` means "Todos".
// Only a query tagged tab=xcalacoco is ours: the Beach Club tab shares the status/startDate/endDate keys
function filtersFromQuery(query) {
  if (query.tab !== 'xcalacoco' || !FILTER_KEYS.some(key => key in query)) return { status: '1' }
  const filters = {}
  FILTER_KEYS.forEach(key => {
    if (key === 'status' && key in query) filters.status = query.status || null
    else if (query[key]) filters[key] = query[key]
  })
  return filters
}

export default {
  components: {
    PaginationTable,
    XcalacocoBookingsFilters,
  },
  data() {
    return {
      initialFilters: filtersFromQuery(this.$route.query),
      rows: [],
      fields: xcalacocoBookingsFields,
      lastFilters: { status: '1' },
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      searchCount: 0,
    }
  },
  async created() {
    await this.search(this.initialFilters)
  },
  methods: {
    ...mapActions('fivesClubCatalogs', ['fetchXcalacocoBookings']),

    async search(filters) {
      this.lastFilters = filters
      // The URL holds the search so browser Back from the detail view restores it
      this.$router.replace({ query: { ...filters, tab: 'xcalacoco' } }).catch(() => {})
      this.isLoading = true
      const result = await this.fetchXcalacocoBookings(filters)
      this.isLoading = false
      this.currentPage = 1
      this.searchCount += 1
      if (result.ok) {
        this.rows = Array.isArray(result.data) ? result.data : []
        return
      }
      this.rows = []
      showAlertMessage('Atención', 'InfoIcon', result.message || FALLBACK_MESSAGE, 'warning', 5000)
    },
    changePage(page) {
      this.currentPage = page
    },
    formatDay: formatXcalacocoDay,
    nightsLabel: xcalacocoNightsLabel,
    statusVariant: xcalacocoStatusVariant,
    guestNames: xcalacocoGuestNames,
  },
}
</script>
